/** Reads a major-unit amount such as "25,000.50" as minor units (kobo); null if it is not a positive amount. */
export function parseMajorAmount(raw: string): number | null {
  // Parsed as text, not a float, so 19.99 is exactly 1999.
  const match = /^(\d+)(?:\.(\d{1,2}))?$/.exec(raw.trim().replaceAll(",", ""));
  if (!match) return null;
  const minor = Number(match[1]) * 100 + Number((match[2] ?? "").padEnd(2, "0"));
  return minor > 0 && Number.isSafeInteger(minor) ? minor : null;
}

export function formatAmount(minor: number, currency: string) {
  return new Intl.NumberFormat("en-NG", { style: "currency", currency, minimumFractionDigits: 2 }).format(minor / 100);
}
